import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/terms")({
	component: Terms
});

function Terms() {
	return (
		<section className="space-y-4">
			<div className="h-[70vh] w-full bg-white rounded-lg p-6 text-sm overflow-y-auto">
				<h2 className="text-xl font-bold mb-4">TERMS AND CONDITIONS</h2>
				<ol className="list-decimal pl-6 space-y-4">
					<li>
						<h3 className="font-semibold">Introduction</h3>
						<p>
							Welcome to Intasida, a digital platform that connects online
							vendors and buyers, facilitating seamless transactions between
							both parties. By accessing and using our website, you agree to be
							bound by these Terms and Conditions. If you do not agree with any
							part of these Terms, please discontinue use of our services
							immediately.
						</p>
					</li>
					<li>
						<h3 className="font-semibold">User Agreement</h3>
						<p>
							By using this website, you confirm that you have read, understood,
							and agreed to abide by these Terms and Conditions. You also
							consent to the collection, processing, and storage of personal
							data provided on the platform in accordance with our Privacy
							Policy.
						</p>
					</li>
					<li>
						<h3 className="font-semibold">Personal Data Processing</h3>
						<p>
							By using Intasida, you acknowledge and consent to the collection
							and processing of your personal data, including but not limited to
							your name, contact details, and transaction history. This
							information will be used to facilitate transactions, enhance user
							experience, and comply with regulatory requirements. For more
							details on how we handle your personal data, please refer to our
							Privacy Policy.
						</p>
					</li>
					<li>
						<h3 className="font-semibold">Role of Intasida</h3>
						<p>
							Intasida acts as an intermediary between online vendors and
							buyers. We do not own, manufacture, or directly sell any goods
							listed on our platform. Any disputes concerning products purchased
							must be resolved between the vendor and the buyer, subject to our
							dispute resolution process.
						</p>
					</li>
					<li>
						<h3 className="font-semibold">Forfeiture of Unclaimed Goods</h3>
						<p>
							If a buyer purchases goods but fails to claim them within a
							reasonable period of time as determined by Intasida, such goods
							shall be deemed forfeited. Intasida reserves the right to dispose
							of or take any other appropriate action regarding such unclaimed
							goods at its sole discretion.
						</p>
					</li>
					<li>
						<h3 className="font-semibold">Payments and Refunds</h3>
						<p>
							All transactions conducted through Intasida must comply with the
							payment policies stated on our platform. Refunds, if applicable,
							will be processed according to the vendor's refund policy and
							subject to any applicable regulations.
						</p>
					</li>
					<li>
						<h3 className="font-semibold">Prohibited Activities</h3>
						<p>
							Users are prohibited from engaging in fraudulent activities,
							misrepresentations, or any unlawful conduct while using Intasida's
							services. Any violations may result in account suspension, legal
							action, or permanent ban from the platform.
						</p>
					</li>
					<li>
						<h3 className="font-semibold">Modifications to Terms</h3>
						<p>
							Intasida reserves the right to amend these Terms and Conditions at
							any time. Continued use of the website following any changes
							constitutes acceptance of the revised Terms.
						</p>
					</li>
					<li>
						<h3 className="font-semibold">Governing Law</h3>
						<p>
							These Terms and Conditions shall be governed by and interpreted in
							accordance with the laws of the Federal Republic of Nigeria.
						</p>
					</li>
					<li>
						<h3 className="font-semibold">Contact Information</h3>
						<p>
							For inquiries regarding these Terms and Conditions, please contact
							us at ….
						</p>
					</li>
				</ol>
			</div>
		</section>
	);
}
